module.exports = __webpack_public_path__ + "2f3d2a4006a9898c39f8dc5d68643b63.png";